import { newApiFetch } from "./utils";

export const getModels = () => newApiFetch("/_the_models", {});
